
<template>
<div class="tabbed-content">
  <div class="table-no-search">
    <datatable
      :source="changeLog"
      :filterable="false"
      :isLoading="isLoading">
      <datatable-column
        v-for="(column, index) in columns"
        :id="column.id"
        :label="column.label"
        :key="index"
        :sortKey="column.sort">
      </datatable-column>
      <template slot="searchLeft">
      </template>
      <template slot="source_template" slot-scope="data">
        <tr>
          <td class="table-15">{{ data.row.date }}</td>
          <td class="table-20">{{ data.row.user }}</td>
          <td class="table-65">{{ data.row.note }}</td>
        </tr>
      </template>
    </datatable>
  </div>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'

export default {
  name: 'VehicleChangeLog',
  props: ['vehicleId'],
  mounted () {
    Promise.all([
      store.functions.vehicles.getChangeLogTable(this.vehicleId, (response) => { this.changeLog = response.data })
    ]).then(response => {
      // pass
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      columns: [
        { id: 'date', label: 'Date', sort: 'id' },
        { id: 'origin', label: 'User' },
        { id: 'note', label: 'Change' }
      ],
      isLoading: true,
      changeLog: []
    }
  },
  components: {
    Datatable,
    DatatableColumn
  },
  methods: {
    refresh () {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleChangeLog.vue